import * as types from './types';

const initialState = {
  query: '',
  page: 1,
  sort: 'name',
  filters: {
    itemNames: [],
    itemCategories: [],
    states: [],
  },
  status: 'done',
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SEARCH_STATUS: {
      const {
        data: { status },
      } = action;
      return { ...state, status };
    }
    case types.SET_SEARCH_PAGE: {
      const {
        data: { page },
      } = action;
      return {
        ...state,
        page,
      };
    }
    case types.SET_SEARCH_SORT: {
      const {
        data: { sort },
      } = action;
      return {
        ...state,
        sort,
      };
    }
    case types.SET_SEARCH_QUERY: {
      const {
        data: { query },
      } = action;
      return {
        ...state,
        query,
      };
    }
    case types.SET_SEARCH_FILTER: {
      const {
        data: { name, values },
      } = action;
      return {
        ...state,
        filters: {
          ...state.filters,
          [name]: values,
        },
      };
    }
    default:
      return state;
  }
};

export default searchReducer;
